import { useContext, useEffect } from "react"
import { AlertContext } from "../../contexts/AlertContext"
import { GlobalModal } from "../Global Modal/GlobalModal";
import './Alert.scss';

const alertDialogSx = {
    '& .MuiDialog-paper': {
        minHeight: "5rem",
        minWidth: "20rem",
        borderRadius: "10px",
    },
    '& .MuiPaper-root': {
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px;",
        backdropFilter: "blur(0.3rem)",
        background: "#FFFFFFDD 0% 0% no-repeat padding-box"
        // Customize the box-shadow property
    },
}


const titleFallback = {
    success: "Success",
    info: "Info",
    warning: "Warning",
    error: "Error"
}

export const Alert = () => {

    const { alertState, setAlertState } = useContext(AlertContext);

    const closeAlert = () => {
        setAlertState(prev => ({ ...prev, open: false }));
    }
    const handleButtonClick = (callback) => {
        closeAlert();
        callback?.();
    }


    return (
        <GlobalModal onClose={closeAlert} open={alertState.open} dialogSx={alertDialogSx} disableBackdrop={alertState.disableBackdrop}>
            <div className="alert-component">
                <div className="alert-header">
                    <div className="alert-title">
                        <i className={`icon-${alertState.type} alert-indicator-icon`}></i>
                        <b>{alertState.title ?? titleFallback[alertState.type]}</b>
                    </div>
                    <button onClick={closeAlert} className="small-size outlined icon">
                        <i className="icon-cross"></i>
                    </button>

                </div>
                <p dangerouslySetInnerHTML={{ __html: alertState.message }}></p>

                <div className="buttons-container">
                    {(alertState.options?.length > 0 ?
                        alertState.options :
                        [
                            { label: "Ok", onClick: alertState.okClick ?? (() => { }) },
                            ...(alertState.cancelClick ? [{ label: "Cancel", onClick: alertState.cancelClick, type: 'danger' }] : [])
                        ]
                    ).map(option => <button onClick={() => handleButtonClick(option.onClick)} key={option.label} className={`filled mid-size ${option.type}`}>{option.label}</button>)
                    }
                </div>
            </div>
        </GlobalModal>
    )

}